// language-catalog.ts — JS/TS twin of the PHP `Language` catalog (includes/additions.php
// `final class Language`'s LIST). Languages are a fixed, stable set (not user-editable), so this
// mirror lets client code resolve a language item_id → display name with ZERO network — e.g. to
// label a preselected, lazily-loaded language <select> before its option pool is fetched.
//
// KEEP IN SYNC with includes/additions.php Language::LIST. If a language is added/renamed there,
// mirror it here (id is the canonical item_id, uppercased on lookup).

export interface LanguageCatalogEntry {
    item_id: string;
    item_name: string;
    variable_name: string;
}

export const LANGUAGE_CATALOG: readonly LanguageCatalogEntry[] = [
    { item_id: '7C713184-C2B3-2270-2ADA-1B3C47CF2FFE', item_name: 'Abolian', variable_name: 'abolian' },
    { item_id: '11797B93-B552-807F-C1D7-B75DAB51EC34', item_name: 'Abyssal', variable_name: 'abyssal' },
    { item_id: '77AC72F7-688C-093D-1E29-067C8ECDC548', item_name: 'Aquan', variable_name: 'aquan' },
    { item_id: 'D31BAE4B-F984-13F2-537D-156D07F2F7BE', item_name: 'Auran', variable_name: 'auran' },
    { item_id: '9CE184D4-669F-C2FC-1FA3-F6D3E55561A0', item_name: 'Common', variable_name: 'common' },
    { item_id: 'CE922467-93C7-3589-86B8-B5C1B12F24DB', item_name: 'Domir', variable_name: 'domir' },
    { item_id: 'F3DD13A6-DBA1-104A-E16D-78CD3513E97C', item_name: 'Draconic', variable_name: 'draconic' },
    { item_id: 'F968E89D-C2FF-FA26-951F-02587238161A', item_name: 'Druidic', variable_name: 'druidic' },
    { item_id: '16F6B377-200C-3FBC-966B-6E9B957A2119', item_name: 'Dwarvish', variable_name: 'dwarvish' },
    { item_id: '3BDE75C8-41C3-6DE0-8CDC-388ED5D89670', item_name: 'Elvish', variable_name: 'elvish' },
    { item_id: '48655553-071F-29AC-071F-E7E9E4D53235', item_name: 'Enochian', variable_name: 'enochian' },
    { item_id: '16F6B377-200C-3FBC-966B-6E9B957A2110', item_name: 'Gnomish', variable_name: 'gnomish' },
    { item_id: 'DFCE3528-A8AF-ACFF-B837-7A89B1E85FB3', item_name: 'Grel', variable_name: 'grel' },
    { item_id: 'EA0C0C09-5B81-A5E2-D325-82330B54A196', item_name: 'Ignan', variable_name: 'ignan' },
    { item_id: '03E06BE0-F073-0D9B-E804-A9F014FAFF07', item_name: 'Infernal', variable_name: 'infernal' },
    { item_id: '3FB72788-E5FE-2B64-2D1F-2A14BCC6284E', item_name: 'Nagh', variable_name: 'nagh' },
    { item_id: '2AC81DE7-B375-9903-CABB-72BAFF74589B', item_name: 'Orcish', variable_name: 'orcish' },
    { item_id: '305B9EAE-E108-C9EE-D31A-475F75AA3380', item_name: 'Primordial', variable_name: 'primordial' },
    { item_id: '32E190D7-0A38-4071-81F7-0EC82089CCD4', item_name: 'Qini', variable_name: 'qini' },
    { item_id: 'E2528842-8503-6034-9AE2-1C28C1893A22', item_name: 'Sign Language', variable_name: 'sign_language' },
    { item_id: '62DCCEE7-C228-2081-F171-F49FA62120D2', item_name: 'Sylvan', variable_name: 'sylvan' },
    { item_id: 'AC7B499B-0F30-B16D-D924-183E9473BDE0', item_name: 'Terran', variable_name: 'terran' },
    { item_id: 'A1ECE347-CF64-8454-67CF-9CA8BDEBFD7D', item_name: 'Thieves Cant', variable_name: 'thieves_cant' },
    { item_id: 'E7039ED2-EA0E-4218-A3BF-931A63F983DA', item_name: 'Umbral', variable_name: 'umbral' },
];

const LANGUAGE_NAME_BY_ID: Record<string, string> = (() => {
    const map: Record<string, string> = {};
    for (const entry of LANGUAGE_CATALOG) {
        map[entry.item_id.toUpperCase()] = entry.item_name;
    }
    return map;
})();

/** Resolve a language item_id → display name from the static catalog. '' on an unknown / empty id. */
export function languageNameById(id: string | null | undefined): string {
    if (!id) return '';
    return LANGUAGE_NAME_BY_ID[String(id).toUpperCase()] ?? '';
}
